module.exports = {"513328100":"甘孜镇","513328101":"查龙镇","513328102":"来马镇","513328200":"呷拉乡","513328201":"色西底乡","513328202":"南多乡","513328203":"生康乡","513328204":"贡隆乡","513328205":"扎科乡","513328207":"昔色乡","513328208":"卡攻乡","513328209":"仁果乡","513328210":"拖坝乡","513328211":"斯俄乡","513328212":"庭卡乡","513328213":"下雄乡","513328214":"四通达乡","513328215":"夺多乡","513328216":"泥柯乡","513328217":"茶扎乡","513328218":"大德乡","513328219":"卡龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513328.json
// module id = 2419
// module chunks = 0